// LoyaltyColumns.js
import { createColumnHelper } from "@tanstack/react-table";
import { formatDate } from './../../utils/formatDate'
import { StatusChip } from "../common/StatusChip";

export const getLoyaltyListColumns = (setSelectedRoyalty, setModalOpen) => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("period", {
      header: "Periodo",
      cell: (info) => {
        const period = info.getValue();
        if (!period) return "—";
        // Extraer solo la parte de fecha sin conversión de zona horaria
        const start = period.start.split('T')[0].split('-').reverse().join('/');
        const end = period.end.split('T')[0].split('-').reverse().join('/');
        return `${start} - ${end}`;
      },
    }),
    columnHelper.accessor("calculation_date", {
      header: "Fecha cálculo",
      cell: (info) =>
        info.getValue() ? formatDate(info.getValue()) : "—",
    }),
    columnHelper.accessor("status", {
      header: "Estado",
      cell: (info) => {
        const status = info.getValue();
        const tone =
          status === "COMPLETED"
            ? "success"
            : status === "PENDING"
            ? "warning"
            : "neutral";
        return <StatusChip tone={tone}>{status}</StatusChip>;
      },
    }),
    columnHelper.display({
      id: "totales",
      header: "Totales por moneda",
      cell: (props) => {
        const totals = props.row.original.total_settlement_by_currency || {};
        const entries = Object.entries(totals);

        if (!entries.length) return <span className="text-muted">—</span>;

        return (
          <div>
            {entries.map(([currency, val]) => (
              <div key={currency}>
                <strong>{currency}:</strong>{" "}
                {Number(val.total_value).toLocaleString()}{" "}
                <span className="text-muted">({val.total_points} pts)</span>
              </div>
            ))}
          </div>
        );
      },
    }),
    columnHelper.display({
      id: "usersCount",
      header: "Usuarios",
      cell: (props) => props.row.original.users?.length ?? 0,
    }),
    columnHelper.display({
      id: "actions",
      header: "Acciones",
      cell: (props) => (
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="ui-icon-btn ui-icon-btn--accent"
            onClick={() => {
              setSelectedRoyalty(props.row.original);
              setModalOpen(true);
            }}
            title="Ver detalle"
          >
            <i className="ri-eye-line" />
          </button>
        </div>
      ),
    }),
  ];
};
